/*!
 * @license: MIT
 * Copyright (c) 2020 Shanord Inc.
 * https://shanord.com
 */
import {AnchorScroll} from '@components/AnchorScroll';
import {ContactForm} from '@components/ContactForm';
import {FixedButton} from '@components/FixedButton';
import {Kv} from '@components/Kv';
import {KvButton} from '@components/KvButton';
import {KvSlider} from '@components/KvSlider';
import {PageIndicator} from '@components/PageIndicator';
import {PreloadImage} from '@components/PreloadImage';
import {Sticky} from '@components/Sticky';
import {Video} from '@components/Video';
import {ViewportAnimation} from '@components/ViewportAnimation';
import {WorksLink} from '@components/WorksLink';
import {createApplicationInitializer} from '@services/ApplicationInitializer';

/* eslint-disable sort-keys */
const appInitializer = createApplicationInitializer({
  '.js-page-indicator': PageIndicator,
  '.js-fixed-button': FixedButton,
  '.js-kv': Kv,
  '.js-kv-slider': KvSlider,
  '.js-kv-button': KvButton,
  '.js-works-link': WorksLink,
  '.js-form': ContactForm,
  '.js-viewport': ViewportAnimation,
  '.js-preload-image': PreloadImage,
  '.js-video': Video,
  '.js-sticky': Sticky,
  'a[href^="#"]': AnchorScroll,
});
/* eslint-enable sort-keys */

appInitializer.init();
